import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { ActiviteitTemplates } from '../../../templates/components/ActiviteitTemplates'
import { StyledError } from '../../../theme/components/StyledError'
import { useActiviteitTemplatesSearch } from '../hooks/useTemplatesSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { ContractinstellingenActiviteiten }

type Props = {
  filters: ContractinstellingenSearchFilters
}

const ContractinstellingenActiviteiten = ({ filters }: Props) => {
  const {
    data: { activiteitTemplates },
    isLoading,
    error,
  } = useActiviteitTemplatesSearch({ filters })

  return (
    <>
      <StyledError error={error} />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      <ActiviteitTemplates
        projectType={'Hoofdleiding'}
        templates={activiteitTemplates}
      />

      {!isLoading && activiteitTemplates.length === 0 && (
        <Typography>Selecteer filters om te zoeken.</Typography>
      )}
    </>
  )
}
